import { ParameterList } from 'src/components/molecules/Parameter';
import {
  Fact,
  readRoutingRule,
  writeRoutingRule,
} from 'src/components/organisms/RoutingRule/helpers';
import { Maybe, RoutingRuleType } from 'src/graphql';
import { RoutingDataSource } from 'src/types';

type Condition = {
  fact: Fact;
  operator: 'in' | 'ArrayIn';
  value: string[];
  path: string;
};

export interface Conditions {
  all: Condition[];
}

export interface RoutingRuleParameters {
  organisation: number;
  destinationGroup?: string;
  rule: Conditions | {};
  priority: number;
  disabled?: boolean;
  name: string;
  groupAssignment?: boolean;
}

export interface StateRule {
  id: string;
  name: string;
  destinationGroup?: Maybe<string>;
  priority: number;
  disabled: boolean;
  selectedDataSource: RoutingDataSource;
  parameterList: ParameterList;
  groupAssignment: boolean;
}

export const rulesAreIdentical = (
  savedRule: StateRule,
  currRule: StateRule,
) => {
  const rulesAreIdentical =
    JSON.stringify(savedRule) === JSON.stringify(currRule);
  return rulesAreIdentical;
};

export const convertFactTypeToDataSource = (conditions: Condition[]) => {
  const factToDataSourceMap = {
    reporter: RoutingDataSource.REPORTER,
    offenders: RoutingDataSource.OFFENDER,
    report: RoutingDataSource.REPORT,
  };
  const fact: Fact | null = conditions ? conditions[0]?.fact : null;
  const dataSource =
    factToDataSourceMap[!fact || fact === 'report' ? 'offenders' : fact];
  return dataSource;
};

export const formatSavedRule = (savedRule: RoutingRuleType) => {
  const {
    id,
    destinationGroup,
    priority,
    disabled,
    name,
    rule,
    groupAssignment,
  } = savedRule;
  const parameterList = readRoutingRule(rule);
  const selectedDataSource = convertFactTypeToDataSource(rule.all);
  const formattedRule: StateRule = {
    id,
    name,
    destinationGroup: destinationGroup ?? undefined,
    priority,
    selectedDataSource,
    parameterList,
    disabled,
    groupAssignment: groupAssignment ?? false,
  };
  return formattedRule;
};

export const formatStateRule = (
  stateRule: StateRule,
  featureFlags?: { isRelationshipToOrgEnabled?: boolean },
) => {
  return {
    id: stateRule.id,
    destinationGroup: stateRule.destinationGroup,
    disabled: stateRule.disabled,
    rule: writeRoutingRule(
      stateRule.parameterList,
      stateRule.selectedDataSource,
      featureFlags,
    ),
    priority: stateRule.priority,
    name: stateRule.name,
    groupAssignment: stateRule.groupAssignment,
  };
};

export const currentStateRuleIsSaved = (
  savedRule: RoutingRuleType,
  currStateRule: StateRule,
) => {
  const formattedSavedRule = savedRule.rule
    ? formatSavedRule(savedRule)
    : ({} as StateRule);
  return rulesAreIdentical(formattedSavedRule, currStateRule);
};
